import axios from "axios";
import { API_BASE as SBIN_API_BASE, buildAuthHeaders } from "./base";

const API = SBIN_API_BASE;

export async function getPublicEmailPreferences(token) {
  const res = await axios.get(`${API}/email-preferences/public`, {
    params: { token },
  });
  return res.data;
}

export async function updatePublicEmailPreferences(payload) {
  const res = await axios.post(`${API}/email-preferences/public`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
}

export async function getPreviewEmailPreferences(salonId, token, category = "all_optional") {
  const res = await axios.get(`${API}/email-preferences/preview`, {
    params: { salon_id: salonId, category },
    headers: buildAuthHeaders(token, { "Content-Type": "application/json" }),
  });
  return res.data;
}

export async function getClientEmailPreferenceLink({
  salonId,
  clientId,
  token,
  category = "all_optional",
}) {
  const res = await axios.get(`${API}/email-preferences/admin/client-link`, {
    params: { salon_id: salonId, client_id: clientId, category },
    headers: buildAuthHeaders(token, { "Content-Type": "application/json" }),
  });
  return res.data;
}
